import React, {Component} from 'react';
import { Container, Row, Col, Tab, Nav, Form, Button, Spinner} from "react-bootstrap";
import { FaSave, FaRegTrashAlt, FaArrowLeft } from 'react-icons/fa';
import { Link } from 'react-router-dom';

import Side from "./Sidebar";
import Top from "./Topbar";
import Crypt from '../lib/Crypt';
import Loader from "./LoaderModal";
import swal from 'sweetalert';
import ChemoMedicinePopup from "./ChemoMedicinePopup";
import ProtocolDosagePopup from "./ProtocolDosagePopup";
import PreConditionMSTPopup from "./PreConditionMSTPopup";
import ReduceDosagePopup from "./ReduceDosagePopup";
import AdverseEffectDisPopup from "./AdverseEffectDisPopup";
import AdverseEffectTerPopup from "./AdverseEffectTerPopup";
import C from '../lib/Config';
import PrimarySitePicker from "./PrimarySitePicker";
import { fetchPrimarySiteOptions, readPrimarySites, buildPrimarySitesPayload, setLeadSite, syncSelection } from '../lib/PrimarySiteUtils';

const protocolTypeArr = [
    { key: Crypt.getUniqueKey('0'), id: '1', label: 'IV' },
    { key: Crypt.getUniqueKey('1'), id: '2', label: 'Oral' }, 
]
const fnRiskArr = [
    { key: Crypt.getUniqueKey('0'), id: 'H', label: 'High (FN Risk 20% or more)' },
    { key: Crypt.getUniqueKey('1'), id: 'I', label: 'Intermediate (FN Risk 10 - 19%)' },
    { key: Crypt.getUniqueKey('2'), id: 'L', label: 'Low (FN Risk < 10%)' }, 
]
const AntiemeticRiskList = [
    { key: Crypt.getUniqueKey('3'), id: '3', label: 'Low' },
    { key: Crypt.getUniqueKey('2'), id: '2', label: 'Moderate' },
    { key: Crypt.getUniqueKey('4'), id: '4', label: 'Minimal' },
    { key: Crypt.getUniqueKey('1'), id: '1', label: 'High' },
]

export default class AddProtocol extends Component {
    constructor(props) {
        super(props);
        this.reduceDosageChild = React.createRef();
        this.protocolDosageChild = React.createRef();
        this.adverseEffectChild = React.createRef();
        this.state = {
            protocolTitle: '', schedule: '', protocolId:'', scheduleDosage: '',  instructStockist: '', antiemeticRisk: '', chemoDoseage: '', fnRiskArr: [], fnRisk: '',
            multiDayCycle: false, treatmentDays: '', primarySiteArr: [],
            // Sites the user picked for the protocol being created. There is no
            // server state to protect here (the protocol does not exist yet), but
            // the save still OMITS the `primarySites` key when this is empty rather
            // than sending [], so the two protocol screens follow one rule. See
            // lib/PrimarySiteUtils.js for why [] is dangerous.
            primarySites: [],
            postChemoMedic: '', gcsfProphylaxis: '', antiProphylaxis: '', instructNurse: '', instructPatient: '', nextVisit: '', drugInteraction: '',
            modificationCBC: '', modificationLFT: '', modificationRFT: '', modificationEvent: '', specialTest: '', adverseEvent: '', riskDeath: '', reference: '',
            scheduleMstArr: [], protocol: [], chemoMedicineList: [], reduceDosageList: [], preConditionMSTList: [], protocolDosageList: [], protocolType: '', protocolTypeArr: [],
            advEffDiscontinueList: [], advEffTerminateList: [], successAlertshow: false, successAlertclose: false, saveLoader: false, showMultipleChemoPopup: false,
            showPreConditionMSTPopup: false, showReduceDosagePopup: false,  showAdverseEffectDisPopup: false, showAdverseEffectTerPopup: false,
            chemoMedicineListIAD: [], chemoDoseageList: [], key:'first',
            instituteId: null, instituteArr: [],
        };
       this.handleChange = this.handleChange.bind(this);
    }

    componentDidMount() {
        this.getAllSchedule();
        this.getAllInstitute();
        this.fetchPrimarySites();
    }

    getAllInstitute = () => {
        const userId = localStorage.getItem('userId');
        return fetch(`${C.getUrl()}/institute/getAllInstituteByUserId/${userId}`)
            .then(res => res.json())
            .then(res => {
                const arr = (Array.isArray(res) ? res : (res.message ? JSON.parse(res.message) : []))
                    .map(d => ({ id: d.instituteId, name: d.instituteName }));
                this.setState({
                    instituteArr: arr,
                    instituteId: arr.length >= 1 ? arr[0].id : null,
                });
            })
            .catch(err => {
                swal({ title: "Warning!", text: "Error fetching institute: " + err, icon: "error", buttons: false, timer: 2000, });
            });
    }

    fetchPrimarySites = () => {
        return fetchPrimarySiteOptions()
            .then(data => {
                this.setState({ primarySiteArr: data });
            })
            .catch(err => {
                swal({ title: "Warning!", text: "Error fetching primary sites: " + err, icon: "error", buttons: false, timer: 2000, });
            });
    }

    handlePrimarySitesChange = (selectedIds) => {
        this.setState(prevState => ({
            primarySites: syncSelection(prevState.primarySites, selectedIds, prevState.primarySiteArr)
        }));
    }

    handleLeadSiteChange = (siteId) => {
        this.setState(prevState => ({
            primarySites: setLeadSite(prevState.primarySites, siteId)
        }));
    }

    getAllSchedule = async () => {
        fetch(C.getUrl() + '/schedule/getAllSchedule')
            .then(res => res.json())
            .then(res => {
                //console.log("TAb3 : " + JSON.stringify(res));
                let data = JSON.parse(res.message);
                var arr = [];
                data.map((item, index) => {
                    let jsonList = new Object();
                    jsonList['key'] = Crypt.getUniqueKey(index);
                    jsonList['id'] = item.selectionId;
                    jsonList['label'] = item.selectionValue;
                    jsonList['scheduleDays'] = item.additionalValue;
                    arr.push(jsonList);
                });
                this.setState({ scheduleMstArr: arr });
            })
            .catch(err => {
                swal({ title: "Warning!", text: "Error : " + err, icon: "error", buttons: false, timer: 2000, });
            });
    }

    handleChange(event){
        if(event.target.name === 'protocolTitle'){
            this.setState({protocolTitle: event.target.value});
        }
        if(event.target.name === 'schedule'){
            this.setState({schedule: event.target.value});
        }
        if(event.target.name === 'scheduleDosage'){
            this.setState({scheduleDosage: event.target.value});
        }
        if(event.target.name === 'protocolType'){
            this.setState({protocolType: event.target.value});
        }
        if(event.target.name === 'antiemeticRisk'){
            this.setState({antiemeticRisk: event.target.value});
        }
        if(event.target.name === 'fnRisk'){
            this.setState({fnRisk: event.target.value});
        }
        if(event.target.name === 'chemoDoseage'){
            this.setState({chemoDoseage: event.target.value});
        }
        if(event.target.name === 'instructNurse'){
            this.setState({instructNurse: event.target.value});
        }
        if(event.target.name === 'instructPatient'){
            this.setState({instructPatient: event.target.value});
        }
        if(event.target.name === 'instructStockist'){
            this.setState({instructStockist: event.target.value});
        }
        if(event.target.name === 'nextVisit'){
            this.setState({nextVisit: event.target.value});
        }
        if(event.target.name === 'drugInteraction'){
            this.setState({drugInteraction: event.target.value});
        }
        if(event.target.name === 'adverseEvent'){
            this.setState({adverseEvent: event.target.value});
        }
        if(event.target.name === 'riskDeath'){
            this.setState({riskDeath: event.target.value});
        }
        if(event.target.name === 'reference'){
            this.setState({reference: event.target.value});
        }
        if (event.target.name === 'schedule') {
            this.setState({ schedule: event.target.value });
        }
        if(event.target.name === 'multiDayCycle'){
            this.setState({multiDayCycle: event.target.checked, treatmentDays: ''});
        }
        if(event.target.name === 'treatmentDays'){
            this.setState({treatmentDays: event.target.value});
        }
    }
    validateProtocol(){
        let formIsValid = true;
        let errors = {};
        if (this.state.protocolTitle === "" || this.state.protocolTitle === null) {
            errors["protocolTitle"] = "Please enter first name";
            formIsValid = false;
        }
        if (this.state.schedule === "" || this.state.schedule === null) {
            errors["schedule"] = "Please select schedule for doctor visit";
            formIsValid = false;
        }
        if (this.state.protocolType === "" || this.state.protocolType === null) {
            errors["protocolType"] = "Please select schedule for doctor visit";
            formIsValid = false;
        }
        if (this.state.scheduleDosage === "" || this.state.scheduleDosage === null) {
            errors["scheduleDosage"] = "Please select schedule for dosage";
            formIsValid = false;
        }
        if (this.state.antiemeticRisk === "" || this.state.antiemeticRisk === null) {
            errors["antiemeticRisk"] = "Please enter antiemetic risk";
            formIsValid = false;
        }
        if (this.state.fnRisk === "" || this.state.fnRisk === null) {
            errors["fnRisk"] = "Please enter Fn risk";
            formIsValid = false;
        }
        if (this.state.chemoDoseage === "" || this.state.chemoDoseage === null) {
            errors["chemoDoseage"] = "Please enter chemo doseage method";
            formIsValid = false;
        }
        if (this.state.instructNurse === "" || this.state.instructNurse === null) {
            errors["instructNurse"] = "Please enter special instruction to nurse";
            formIsValid = false;
        }
        if (this.state.instructPatient === "" || this.state.instructPatient === null) {
            errors["instructPatient"] = "Please enter special instruction to patients";
            formIsValid = false;
        }
        if (this.state.instructStockist === "" || this.state.instructStockist === null) {
            errors["instructStockist"] = "Please enter stockist instruction";
            formIsValid = false;
        }
        if (this.state.nextVisit === "" || this.state.nextVisit === null) {
            errors["nextVisit"] = "Please enter next visit instructions";
            formIsValid = false;
        }
        if (this.state.drugInteraction === "" || this.state.drugInteraction === null) {
            errors["drugInteraction"] = "Please enter drug interactions";
            formIsValid = false;
        }
        if (this.state.adverseEvent === "" || this.state.adverseEvent === null) {
            errors["adverseEvent"] = "Please enter adverse events";
            formIsValid = false;
        }
        if (this.state.riskDeath === "" || this.state.riskDeath === null) {
            errors["riskDeath"] = "Please enter risk of death";
            formIsValid = false;
        }
        if (this.state.reference === "" || this.state.reference === null) {
            errors["reference"] = "Please enter reference";
            formIsValid = false;
        }
        const treatmentDaysPattern = /^[1-9]\d*(-[1-9]\d*)?(,[1-9]\d*(-[1-9]\d*)?)*$/;
        if (this.state.multiDayCycle) {
            if (!this.state.treatmentDays || this.state.treatmentDays.trim() === '') {
                errors["treatmentDays"] = "Please enter treatment days (e.g. 1-5 or 1,7,15)";
                formIsValid = false;
            } else if (!treatmentDaysPattern.test(this.state.treatmentDays.trim())) {
                errors["treatmentDays"] = "Invalid format. Use ranges (e.g. 1-5), comma-separated days (e.g. 1,7,15), or a combination (e.g. 1-3,6-8). All day numbers must be greater than 0.";
                formIsValid = false;
            }
        }
        this.setState({protocol: errors });
        return formIsValid;
    }

    deleteChemo = (chemoMedicine) => {
        //console.log("chemoMedicine : "+chemoMedicine);
        let arr = this.state.chemoMedicineList;
        const requiredIndex = arr.findIndex(el => {
            return el.medicineId === chemoMedicine;
        });
        //console.log("requiredIndex : "+requiredIndex);
        if(requiredIndex === -1){
            return false;
        };

        arr.splice(requiredIndex, 1);
        //console.log("tempArr : "+JSON.stringify(arr));
        this.setState({ chemoMedicineList : arr });
    }

    deleteProtocolDosage = (chemoMedicineDosageID, dosageValues, dosageQtys) => {
        //console.log("chemoMedicineDosageID : "+chemoMedicineDosageID);
        let arr = this.state.protocolDosageList;
        const requiredIndex = arr.findIndex(el => {
            if(el.chemoMedicineDosageID === chemoMedicineDosageID && el.dosageValues === dosageValues && el.dosageQtys === dosageQtys){
                return el.chemoMedicineDosageID === chemoMedicineDosageID;
            }
        });
        //console.log("requiredIndex : "+requiredIndex);
        if(requiredIndex === -1){
            return false;
        };

        arr.splice(requiredIndex, 1);
        //console.log("tempArr : "+JSON.stringify(arr));
        this.setState({ protocolDosageList : arr });
    }

    deletePrecondition = (reportParamsID, preConditionValues) => {
        //console.log("reportParamsID : "+reportParamsID);
        let arr = this.state.preConditionMSTList;
        const requiredIndex = arr.findIndex(el => {
            if(el.reportParamsID === reportParamsID && el.preConditionValues === preConditionValues){
                return el.reportParamsID === reportParamsID;
            }
        });
        //console.log("requiredIndex : "+requiredIndex);
        if(requiredIndex === -1){
            return false;
        };

        arr.splice(requiredIndex, 1);
        //console.log("tempArr : "+JSON.stringify(arr));
        this.setState({ preConditionMSTList : arr });
    }

    deleteReduceDosage = (chemoMedicineDosageID, reduceDosageReportID) => {
        //console.log("chemoMedicineDosageID : "+chemoMedicineDosageID);
        let arr = this.state.reduceDosageList;
        const requiredIndex = arr.findIndex(el => {
            if(el.chemoMedicineDosageID === chemoMedicineDosageID && el.reduceDosageReportID === reduceDosageReportID){
                return el.chemoMedicineDosageID === chemoMedicineDosageID;
            }
        });
        //console.log("requiredIndex : "+requiredIndex);
        if(requiredIndex === -1){
            return false;
        };

        arr.splice(requiredIndex, 1);
        //console.log("tempArr : "+JSON.stringify(arr));
        this.setState({ reduceDosageList : arr });
    }

    deleteAdverseEventDIS = (reportID) => {
        //console.log("reportID : "+reportID);
        let arr = this.state.advEffDiscontinueList;
        const requiredIndex = arr.findIndex(el => {
            return el.reportID === reportID;
        });
        //console.log("requiredIndex : "+requiredIndex);
        if(requiredIndex === -1){
            return false;
        };

        arr.splice(requiredIndex, 1);
        //console.log("tempArr : "+JSON.stringify(arr));
        this.setState({ advEffDiscontinueList : arr });
    }

    deleteAdverseEffectTER = (reportID) => {
        //console.log("reportID : "+reportID);
        let arr = this.state.advEffTerminateList;
        const requiredIndex = arr.findIndex(el => {
            return el.reportID === reportID;
        });
        //console.log("requiredIndex : "+requiredIndex);
        if(requiredIndex === -1){
            return false;
        };

        arr.splice(requiredIndex, 1);
        //console.log("tempArr : "+JSON.stringify(arr));
        this.setState({ advEffTerminateList : arr });
    }

    saveChemo(event){
            var chemoMedicineDTOList = [];
            var tempProtocolId = this.state.protocolId;
            this.state.chemoMedicineList.forEach(function (obj) {
                let data = {
                    chemoMedicineId: obj.chemoMedicineId,
                    activeInd: 'Y',
                    chemoInstructions: obj.chemoInstructions,
                    createdDt: new Date(),
                    updatedDt: new Date(),
                    createdByIdUser: {
                        userId: localStorage.getItem('userId')
                    },
                    updatedByIdUser: {
                        userId: localStorage.getItem('userId')
                    }, 
                    medicineMstDto: {
                        medicineId: obj.medicineId,
                        medicineName: obj.chemoMedicineName
                    }, 
                    protocolMstDTO: {
                        protocolId: tempProtocolId
                    }
                }
                chemoMedicineDTOList.push(data);
            });
            return fetch(C.getUrl() + '/chemoMedicine/saveChemoMedicine', {
                method: 'POST',
                mode: 'cors',
                body: JSON.stringify(chemoMedicineDTOList),
                headers: {
                    'Content-Type': 'application/json'
                }
            })
            .then(res => res.json())
            .then(res => {
                let obj = res;
                let error = obj.subErrors;
                if (error !== null && error !== "") {
                    //alert(error);
                    swal({ title: "Warning!", text: "Error : " + error, icon: "error", buttons: false, timer: 2000, });
                } else {
                    this.setState({ saveLoader: true });
                    setTimeout(() => {
                        this.setState({ saveLoader: false })
                    }, 3000)
                    let objmsg = JSON.parse(obj.message);
                    let tempArr = [];
                    objmsg.map(function (d) {
                        tempArr.push({ chemoInstructions: d.chemoInstructions, chemoMedicineName: d.medicineMstDto.medicineName, chemoMedicineId: d.chemoMedicineId });
                    });
                    this.setState({chemoDoseageList: tempArr });
                    swal({ title: "Chemo medicine saved successfully", icon: "success", buttons: false, timer: 2000, });
                    setTimeout(() => { this.setState({ key: 'third'}) }, 2000)
                }
            })
            .catch(err => {
                 swal({ title: "Warning!", text: "Error : " + err, icon: "error", buttons: false, timer: 2000, });
            });
    }
    saveAdverseEffectTer(event){
            var adverseEffectTerminationDTOList = [];
            var tempProtocolId = this.state.protocolId;
            this.state.advEffTerminateList.forEach(function (obj) {
                let data = {
                    chemoMedAdvEffectXId: obj.chemoMedAdvEffectXId,
                    activeInd: 'Y',
                    message: obj.message, 
                    reportParameterMstDTO: {
                        reportParamId: obj.reportID,
                        reportParamName: obj.reportName
                    }, 
                    protocolMstDTO: {
                        protocolId: tempProtocolId
                    }
                }
                adverseEffectTerminationDTOList.push(data);
            });
            return fetch(C.getUrl() + '/adverseEffectMaster/saveAdverseEffectTermination', {
                method: 'POST',
                mode: 'cors',
                body: JSON.stringify(adverseEffectTerminationDTOList),
                headers: {
                    'Content-Type': 'application/json'
                }
            })
            .then(res => res.json())
            .then(res => {
                let obj = res;
                let error = obj.subErrors;
                if (error !== null && error !== "") {
                    swal({ title: "Warning!", text: "Error : " + error, icon: "error", buttons: false, timer: 2000, });
                } else {
                    this.setState({ saveLoader: true });
                    setTimeout(() => {this.setState({ saveLoader: false })}, 3000)
                    let objmsg = JSON.parse(obj.message);
                    swal({ title: "Protocol created successfully", icon: "success", buttons: false, timer: 2000, });
                    setTimeout(() => { this.setState({ key: 'second'}) }, 4000)
                }
            })
            .catch(err => {
                 swal({ title: "Warning!", text: "Error : " + err, icon: "error", buttons: false, timer: 2000, });
            });
    }
    saveAdverseDiscontinue(event){
            var adverseEffectDiscontinueDTOList = [];
            this.state.advEffDiscontinueList.forEach(function (obj) {
                let data = {
                    adverseEffectDiscontinueId: obj.adverseEffectDiscontinueId,
                    activeInd: 'Y',
                    chemoInstructions: obj.chemoInstructions,
                    createdDt: new Date(),
                    updatedDt: new Date(),
                    createdByIdUser: {
                        userId: localStorage.getItem('userId')
                    },
                    updatedByIdUser: {
                        userId: localStorage.getItem('userId')
                    }, 
                    chemoMedicineDTO: {
                        chemoMedicineId: obj.chemoMedicineDosageID
                    }, 
                    reportParameterMstDTO: {
                        reportParamId: obj.reportID
                    },
                }
                adverseEffectDiscontinueDTOList.push(data);
            });
            return fetch(C.getUrl() + '/adverseEffectMaster/saveAdverseEffectDiscontinue', {
                method: 'POST',
                mode: 'cors',
                body: JSON.stringify(adverseEffectDiscontinueDTOList),
                headers: {
                    'Content-Type': 'application/json'
                }
            })
            .then(res => res.json())
            .then(res => {
                let obj = res;
                let error = obj.subErrors;
                if (error !== null && error !== "") {
                    swal({ title: "Warning!", text: "Error : " + error, icon: "error", buttons: false, timer: 2000, });
                } else {
                    this.setState({ saveLoader: true });
                    setTimeout(() => {this.setState({ saveLoader: false })}, 3000)
                    let objmsg = JSON.parse(obj.message);
                    swal({ title: "Adverse events saved successfully", icon: "success", buttons: false, timer: 2000, });
                    setTimeout(() => { this.setState({ key: 'seventh'}) }, 4000)
                }
            })
            .catch(err => {
                 swal({ title: "Warning!", text: "Error : " + err, icon: "error", buttons: false, timer: 2000, });
            });
    }
    saveReduceDosage(event){
            var chemoMedicineAdverseEffectXDTOList = [];
            this.state.reduceDosageList.forEach(function (obj) {
                let data = {
                    chemoMedicineAdverseEffectXId: obj.chemoMedicineAdverseEffectXId,
                    activeInd: 'Y',
                    createdDt: new Date(),
                    updatedDt: new Date(),
                    chemoMedicineDTO: {
                        chemoMedicineId: obj.chemoMedicineDosageID,
                        medicineMstDto: {
                            medicineName: obj.chemoMedicineDosageValue
                        }
                    },
                    createdByIdUser: {
                        userId: localStorage.getItem('userId')
                    }, 
                    updatedByIdUser: {
                        userId: localStorage.getItem('userId')
                    }, 
                    reportParameterMstDTO: {
                        reportParamId: obj.reduceDosageReportID,
                        reportParamName: obj.reduceDosageReportValues
                    }
                }
                chemoMedicineAdverseEffectXDTOList.push(data);
            });
            return fetch(C.getUrl() + '/chemoMedicine/saveChemoMedicineAdverseEffect', {
                method: 'POST',
                mode: 'cors',
                body: JSON.stringify(chemoMedicineAdverseEffectXDTOList),
                headers: {
                    'Content-Type': 'application/json'
                }
            })
            .then(res => res.json())
            .then(res => {
                let obj = res;
                let error = obj.subErrors;
                if (error !== null && error !== "") {
                    swal({ title: "Warning!", text: "Error : " + error, icon: "error", buttons: false, timer: 2000, });
                } else {
                    this.setState({ saveLoader: true });
                    setTimeout(() => {this.setState({ saveLoader: false })}, 3000)
                    let objmsg = JSON.parse(obj.message);
                    swal({ title: "Reduce dosage saved successfully", icon: "success", buttons: false, timer: 2000, });
                    setTimeout(() => { this.setState({ key: 'sixth'}) }, 4000)
                }
            })
            .catch(err => {
                 swal({ title: "Warning!", text: "Error : " + err, icon: "error", buttons: false, timer: 2000, });
            });
    }
    savePreConditionMST(event){
            var protocolPreconditionDTOList = [];
            var trmpProtocolId = this.state.protocolId;
            this.state.preConditionMSTList.forEach(function (obj) {
                let data = {
                    protocolpreconditionsId: obj.protocolpreconditionsId,
                    activeInd: 'Y',
                    operator: obj.preConditionListsID,
                    value: obj.preConditionValues,
                    createdDt: new Date(),
                    updatedDt: new Date(),
                    createdByIdUser: {
                        userId: localStorage.getItem('userId')
                    },
                    updatedByIdUser: {
                        userId: localStorage.getItem('userId')
                    }, 
                    reportParameterMstDTO: {
                        reportParamId: obj.reportParamsID,
                        reportParamName: obj.reportParamsNames
                    }, 
                    protocolMstDTO: {
                        protocolId: trmpProtocolId
                    }
                }
                protocolPreconditionDTOList.push(data);
            });
            return fetch(C.getUrl() + '/protocol/saveProtocolPreCondition', {
                method: 'POST',
                mode: 'cors',
                body: JSON.stringify(protocolPreconditionDTOList),
                headers: {
                    'Content-Type': 'application/json'
                }
            })
            .then(res => res.json())
            .then(res => {
                let obj = res;
                let error = obj.subErrors;
                if (error !== null && error !== "") {
                    swal({ title: "Warning!", text: "Error : " + error, icon: "error", buttons: false, timer: 2000, });
                } else {
                    this.setState({ saveLoader: true });
                    setTimeout(() => {this.setState({ saveLoader: false })}, 3000)
                    let objmsg = JSON.parse(obj.message);
                    swal({ title: "Pre-condition master saved successfully", icon: "success", buttons: false, timer: 2000, });
                    setTimeout(() => { this.setState({ key: 'fifth'}) }, 4000)
                }
            })
            .catch(err => {
                 swal({ title: "Warning!", text: "Error : " + err, icon: "error", buttons: false, timer: 2000, }); 
            });
    }
    saveProtocolDosage(event){
            var chemoMedicineDosageDTOList = [];
            this.state.protocolDosageList.forEach(function (obj) {
                let data = {
                    chemoMedicineDId: obj.chemoMedicineDId,
                    activeInd: 'Y',
                    chemoInstructions: obj.chemoInstructions,
                    createdDt: new Date(),
                    updatedDt: new Date(),
                    level: obj.dosageLevels,
                    quantity: obj.dosageQtys,
                    unitMstDto: {
                        unitId: obj.dosageUnits,
                        unitName: obj.dosageUnitValues
                    },
                    updatedByIdUser: {
                        userId: localStorage.getItem('userId')
                    },
                    createdByIdUser: {
                        userId: localStorage.getItem('userId')
                    },
                    chemoMedicineDTO: {
                        chemoMedicineId: obj.chemoMedicineDosageID
                    }
                }
                chemoMedicineDosageDTOList.push(data);
            });
            return fetch(C.getUrl() + '/chemoMedicine/saveChemoMedicineDosage', {
                method: 'POST',
                mode: 'cors',
                body: JSON.stringify(chemoMedicineDosageDTOList),
                headers: {
                    'Content-Type': 'application/json'
                }
            })
            .then(res => res.json())
            .then(res => {
                let obj = res;
                let error = obj.subErrors;
                if (error !== null && error !== "") {
                    swal({ title: "Warning!", text: "Error : " + error, icon: "error", buttons: false, timer: 2000, });
                } else {
                    this.setState({ saveLoader: true });
                    setTimeout(() => { this.setState({ saveLoader: false }) }, 3000)
                    let objmsg = JSON.parse(obj.message); 
                    swal({ title: "Protocol dosage saved successfully", icon: "success", buttons: false, timer: 2000, });
                    setTimeout(() => { this.setState({ key: 'fourth'}) }, 4000)
                }
            })
            .catch(err => {
                 swal({ title: "Warning!", text: "Error : " + err, icon: "error", buttons: false, timer: 2000, });
            });
    }
    saveProtocol(event){ 
        let isThisValidForm = false;
        if (this.validateProtocol()) { 
            isThisValidForm = true;
            let data = {
                scheduleMstDTO: {
                    scheduleId: this.state.schedule
                },
                dosageFrequency: {
                    scheduleId: this.state.scheduleDosage
                },
                createdByIdUser: {
                    userId: localStorage.getItem('userId')
                },
                // Required whenever `primarySites` is sent — without it the save
                // fails with "Cannot save protocol primary sites without a user id".
                updatedByIdUser: {
                    userId: localStorage.getItem('userId')
                },
                chemoTypeId  : this.state.protocolType,
                protocolDesc  : this.state.protocolTitle,
                protocolName  : this.state.protocolTitle,
                antiemeticRiskLvlId  : this.state.antiemeticRisk,
                fnRisk  : this.state.fnRisk,
                nurseInstructions  : this.state.instructNurse,
                patientInstructions  : this.state.instructPatient,
                nextVisitInstructions  : this.state.nextVisit,
                drugInteractions  : this.state.drugInteraction,
                antiallergicMedications  : this.state.instructStockist,
                chemoTreatment  : this.state.chemoDoseage,
                chemoDoseageMethod  : this.state.chemoDoseage,
                deathRisk  : this.state.riskDeath,
                reference  : this.state.reference,
                adverseEvents : this.state.adverseEvent,
                instituteId  : this.state.instituteId,
                multiDayCycle: this.state.multiDayCycle,
                treatmentDays: this.state.multiDayCycle ? this.state.treatmentDays : null,
                // Omit the key entirely when no site was picked — never send [].
                // The deprecated `primarySite` string is not sent; it is ignored
                // on write and would do nothing.
                ...(this.state.primarySites.length > 0 && {
                    primarySites: buildPrimarySitesPayload(this.state.primarySites)
                }),
            }
            return fetch(C.getUrl() + '/protocol/saveUpdate', {
                method: 'POST',
                mode: 'cors',
                body: JSON.stringify(data),
                headers: {
                    'Content-Type': 'application/json'
                }
            })
            .then(res => res.json())
            .then(res => {
                let obj = res;
                // Primary-site failures come back as HTTP 404 carrying statusCode 400
                // (an odd pre-existing mapping in this controller). fetch() does not
                // reject on 404, and these bodies have no `subErrors`, so without this
                // branch the check below would report "Error : undefined". The useful
                // text is in `debugMessage` — `message` is always "Unexpected error".
                if (obj.statusCode !== undefined && obj.statusCode !== 200) {
                    const detail = process.env.NODE_ENV !== 'production' && obj.debugMessage
                        ? obj.debugMessage
                        : (obj.message || "Could not create the protocol. Please retry.");
                    swal({ title: "Warning!", text: detail, icon: "error", buttons: false, timer: 4000, });
                    return;
                }
                let error = obj.subErrors;
                if (error !== null && error !== "") {
                    swal({ title: "Warning!", text: "Error : " + error, icon: "error", buttons: false, timer: 3000, });
                } else {
                    this.setState({ saveLoader: true });
                    setTimeout(() => { this.setState({ saveLoader: false }) }, 3000)
                    let objmsg = JSON.parse(obj.message);
                    if(objmsg!=null&&objmsg.protocolId!=0){
                        console.log("Protocol Save Res Inside IF");
                        this.setState({ protocolId: objmsg.protocolId })
                    }
                    // Reflect the link set the server actually stored (including the
                    // lead it settled on) rather than the raw form selection.
                    const savedSites = readPrimarySites(objmsg);
                    if (savedSites !== null) {
                        this.setState({ primarySites: savedSites });
                    }
                    swal({ title: "Protocol created successfully", icon: "success", buttons: false, timer: 3000, });
                    setTimeout(() => { this.setState({ key: 'second'}) }, 4000)
                }
            })
            .catch(err => {
                 swal({ title: "Warning!", text: "Error : " + err, icon: "error", buttons: false, timer: 3000, });
            });
        }
    }
    closeChemoMedicinePopup = () => {
        this.setState({ showChemoMedicinePopup: false });
    }
    showChemoMedicinePopup = () => {
        this.setState({ showChemoMedicinePopup: true });
    }
    closeProtocolDosagePopup = () => {
        this.setState({ showProtocolDosagePopup: false });
    }
    showProtocolDosagePopup = () => {
        this.setState({ showProtocolDosagePopup: true });
        this.protocolDosageChild.current.getProtocolDosageDetail(this.state.chemoDoseageList);
    }
    closePreConditionMSTPopup = () => {
        this.setState({ showPreConditionMSTPopup: false });
    }
    showPreConditionMSTPopup = () => {
        this.setState({ showPreConditionMSTPopup: true });
    }
    closeReduceDosagePopup = () => {
        this.setState({ showReduceDosagePopup: false });
    }
    showReduceDosagePopup = () => {
        this.setState({ showReduceDosagePopup: true });
        this.reduceDosageChild.current.getReduceDosageDetail(this.state.chemoDoseageList);
    }
    closeAdverseEffectDisPopup = () => {
        this.setState({ showAdverseEffectDisPopup: false });
    }
    showAdverseEffectDisPopup = () => {
        this.setState({ showAdverseEffectDisPopup: true }); 
        this.adverseEffectChild.current.getAdverseEffectDetail(this.state.chemoDoseageList);
    }
    closeAdverseEffectTerPopup = () => {
        this.setState({ showAdverseEffectTerPopup: false });
    }
    showAdverseEffectTerPopup = () => {
        this.setState({ showAdverseEffectTerPopup: true });
    }
    setChemoMedicineHandler = (chemoMedicineData) => { 
        var chemoMedicineDataTemp= this.state.chemoMedicineList;
        chemoMedicineDataTemp.push(chemoMedicineData);
        this.setState({ chemoMedicineList: chemoMedicineDataTemp }); 
        this.setState({ showChemoMedicinePopup: false });
    }
    setProtocolDosageHandler = (protocolDosageData) => { 
        var protocolDosageDataTemp= this.state.protocolDosageList;
        protocolDosageDataTemp.push(protocolDosageData);
        this.setState({ protocolDosageList: protocolDosageDataTemp }); 
        this.setState({ showProtocolDosagePopup: false });
    }
    setPreConditionMSTHandler = (preConditionMSTData) => { 
        var preConditionMSTDataTemp= this.state.preConditionMSTList;
        preConditionMSTDataTemp.push(preConditionMSTData);
        this.setState({ preConditionMSTList: preConditionMSTDataTemp }); 
        this.setState({ showPreConditionMSTPopup: false });
    }
    setReduceDosageHandler = (reduceDosageData) => { 
        var reduceDosageDataTemp= this.state.reduceDosageList;
        reduceDosageDataTemp.push(reduceDosageData);
        this.setState({ reduceDosageList: reduceDosageDataTemp }); 
        this.setState({ showReduceDosagePopup: false });
    }
    setAdvEffDiscontinueHandler = (advEffDiscontinueData) => { 
        var advEffDiscontinueDataTemp= this.state.advEffDiscontinueList;
        advEffDiscontinueDataTemp.push(advEffDiscontinueData);
        this.setState({ advEffDiscontinueList: advEffDiscontinueDataTemp }); 
        this.setState({ showAdverseEffectDisPopup: false });
    }
    setAdvEffTerminateHandler = (advEffTerminateData) => { 
        var advEffTerminateDataTemp= this.state.advEffTerminateList;
        advEffTerminateDataTemp.push(advEffTerminateData);
        this.setState({ advEffTerminateList: advEffTerminateDataTemp }); 
        this.setState({ showAdverseEffectTerPopup: false });
    }

    render() {
        const { scheduleMstArr, chemoMedicineList, key } = this.state;
        const _this = this;
        return (
            <div className="d-flex" id="wrapper">
                {<Side />}
                <div id="content-wrapper" className="d-flex flex-column">
                    <div id="content">
                        {<Top />}
                        <Container fluid>
                            <div className="app-content">
                                <section className="section">
                                    <Link to="/ProtocolMaster" className="btn btn-light"><FaArrowLeft className='fs-18' size='2.0rem' style={{verticalAlign: 'baseline'}}/> </Link> 
                                    <h3 className="fs-18 ml-3 header_title text-black mb-4">Add Protocol</h3>
                                    <div className="dropdown-divider pb-2"></div>
                                    <Tab.Container id="left-tabs-example" defaultActiveKey="first" activeKey={key}>
                                        <Row>
                                            <Col sm={2}>
                                                <div className="card">
                                                    <div className="card-body p-0" id="mycard-collapse">
                                                        <Nav variant="pills" className="flex-column list-group list-cyan">
                                                            <Nav.Item><Nav.Link className="list-group-item list-group-item-action radius-0" eventKey="first">Protocol Details</Nav.Link></Nav.Item>
                                                            <Nav.Item><Nav.Link className="list-group-item list-group-item-action radius-0" eventKey="second">Chemo Medicine</Nav.Link></Nav.Item> 
                                                            <Nav.Item><Nav.Link className="list-group-item list-group-item-action radius-0" eventKey="third">Protocol Dosage</Nav.Link></Nav.Item>
                                                            <Nav.Item><Nav.Link className="list-group-item list-group-item-action radius-0" eventKey="fourth">Pre-Condition Master</Nav.Link></Nav.Item>
                                                            <Nav.Item><Nav.Link className="list-group-item list-group-item-action radius-0" eventKey="fifth">Reduce Dosage</Nav.Link></Nav.Item>
                                                            <Nav.Item><Nav.Link className="list-group-item list-group-item-action radius-0" eventKey="sixth">Adverse Event Discontinue</Nav.Link></Nav.Item>
                                                            <Nav.Item><Nav.Link className="list-group-item list-group-item-action radius-0" eventKey="seventh">Adverse Event Termination</Nav.Link></Nav.Item>
                                                        </Nav>
                                                    </div>
                                                </div>
                                            </Col>
                                            <Col sm={10}>
                                                <Tab.Content>
                                                    <Tab.Pane eventKey="first">
                                                        <div id="collapseDraft" className="card border-0 pb-0 collapse show" data-parent="#accordion">
                                                            <div className="card-body container-fluid">
                                                                <Row className="mb-3">
                                                                    <Col lg='4'>
                                                                        <Form.Group>
                                                                            <Form.Label>Protocol Title</Form.Label>
                                                                            <Form.Control type='text' placeholder='' name='protocolTitle' onChange={this.handleChange} />
                                                                            <div className="invalid-feedback">{this.state.protocol["protocolTitle"]}</div>
                                                                        </Form.Group>
                                                                    </Col>
                                                                    <Col lg='4'>
                                                                        <PrimarySitePicker
                                                                            idPrefix="add-protocol"
                                                                            options={this.state.primarySiteArr}
                                                                            selectedSites={this.state.primarySites}
                                                                            onChange={this.handlePrimarySitesChange}
                                                                            onLeadChange={this.handleLeadSiteChange}
                                                                        />
                                                                    </Col>
                                                                    <Col lg='4'>
                                                                        <Form.Group>
                                                                            <Form.Label>Protocol Type</Form.Label>
                                                                            <Form.Control as="select" id="" name='protocolType' value={this.state.protocolType} onChange={this.handleChange}>
                                                                                <option value="DEFAULT">- Select Type -</option>
                                                                                {
                                                                                    protocolTypeArr.map((item, i) => {
                                                                                            return (
                                                                                                <option key={item.key} value={item.id}>{`${item.label}`}</option>
                                                                                            );
                                                                                        })
                                                                                    }
                                                                            </Form.Control>
                                                                        </Form.Group>
                                                                        <div className="invalid-feedback">{this.state.protocol["schedule"]}</div>
                                                                    </Col>
                                                                    <Col lg='4'>
                                                                        <Form.Group>
                                                                            <Form.Label>Schedule for doctor visit</Form.Label>
                                                                            <Form.Control as="select" id="" name='schedule' value={this.state.schedule} onChange={this.handleChange}>
                                                                                <option value="DEFAULT">- Select Schedule -</option>
                                                                                {
                                                                                    scheduleMstArr.map((item, i) => {
                                                                                            return (
                                                                                                <option key={item.key} value={item.id}>{`${item.label}`}</option>
                                                                                            );
                                                                                        })
                                                                                    }
                                                                            </Form.Control>
                                                                        </Form.Group>
                                                                        <div className="invalid-feedback">{this.state.protocol["schedule"]}</div>
                                                                    </Col>
                                                                    <Col lg='4'>
                                                                        <Form.Group>
                                                                            <Form.Label>Antiemetic Risk</Form.Label>
                                                                            <Form.Control as="select" id="" name='antiemeticRisk' value={this.state.antiemeticRisk} onChange={this.handleChange}>
                                                                                <option value="DEFAULT">- Select Antiemetic Risk-</option>
                                                                                {
                                                                                    AntiemeticRiskList.map((item, i) => {
                                                                                        return (
                                                                                            <option key={item.key} value={item.id}>{`${item.label}`}</option>
                                                                                        );
                                                                                    })
                                                                                }
                                                                            </Form.Control>
                                                                            <div className="invalid-feedback">{this.state.protocol["antiemeticRisk"]}</div>
                                                                        </Form.Group>
                                                                    </Col>
                                                                    <Col lg='4'>
                                                                        <Form.Group>
                                                                            <Form.Label>FN Risk(%)</Form.Label>
                                                                            <Form.Control as="select" id="" name='fnRisk' value={this.state.fnRisk} onChange={this.handleChange}>
                                                                                <option value="DEFAULT">- Select Risk Level -</option>
                                                                                {
                                                                                    fnRiskArr.map((item, i) => {
                                                                                        return (
                                                                                            <option key={item.key} value={item.id}>{`${item.label}`}</option>
                                                                                        );
                                                                                    })
                                                                                }
                                                                            </Form.Control>
                                                                            <div className="invalid-feedback">{this.state.protocol["fnRisk"]}</div>
                                                                        </Form.Group>
                                                                    </Col>
                                                                    <Col lg='4'>
                                                                        <Form.Group>
                                                                            <Form.Label>Schedule for dosage</Form.Label>
                                                                            <Form.Control as="select" id="" name='scheduleDosage' value={this.state.scheduleDosage} onChange={this.handleChange}>
                                                                                <option value="DEFAULT">- Select Schedule -</option>
                                                                                {
                                                                                        scheduleMstArr.map((item, i) => {
                                                                                            return (
                                                                                                <option key={item.key} value={item.id}>{`${item.label}`}</option>
                                                                                            );
                                                                                        })
                                                                                    }
                                                                            </Form.Control>
                                                                            <div className="invalid-feedback">{this.state.protocol["scheduleDosage"]}</div>
                                                                        </Form.Group>
                                                                    </Col>
                                                                    <Col lg='4'>
                                                                        <Form.Group>
                                                                            <Form.Check
                                                                                type='checkbox'
                                                                                label='Multi-Day Cycle'
                                                                                name='multiDayCycle'
                                                                                checked={this.state.multiDayCycle}
                                                                                onChange={this.handleChange}
                                                                                className='mt-4 pt-2'
                                                                            />
                                                                        </Form.Group>
                                                                    </Col>
                                                                    {this.state.multiDayCycle && (
                                                                        <Col lg='4'>
                                                                            <Form.Group>
                                                                                <Form.Label>Treatment Days</Form.Label>
                                                                                <Form.Control type='text' placeholder='e.g. 1-5 or 1,7,15' name='treatmentDays' onChange={this.handleChange} />
                                                                                <div className="invalid-feedback">{this.state.protocol["treatmentDays"]}</div>
                                                                            </Form.Group>
                                                                        </Col>
                                                                    )}
                                                                    <Col lg='12'>
                                                                        <Form.Group>
                                                                            <Form.Label>Chemotherapy Dosage Method</Form.Label>
                                                                            <Form.Control as='textarea' placeholder='' maxLength='65535' rows={2} name='chemoDoseage' onChange={this.handleChange}/>
                                                                            <div className="invalid-feedback">{this.state.protocol["chemoDoseage"]}</div>
                                                                        </Form.Group>
                                                                    </Col>
                                                                </Row>
                                                                <Row>
                                                                    <Col lg='6'>
                                                                        <Form.Group>
                                                                            <Form.Label>Special Instruction to Nurse</Form.Label>
                                                                            <Form.Control as='textarea' className="custom-height" placeholder='' rows={2} name='instructNurse' onChange={this.handleChange}/>
                                                                            <div className="invalid-feedback">{this.state.protocol["instructNurse"]}</div>
                                                                        </Form.Group>
                                                                    </Col>
                                                                    <Col lg='6'>
                                                                        <Form.Group>
                                                                            <Form.Label>Special Instruction to Patients</Form.Label>
                                                                            <Form.Control as='textarea' className="custom-height" placeholder='' rows={2} name='instructPatient' onChange={this.handleChange}/>
                                                                            <div className="invalid-feedback">{this.state.protocol["instructPatient"]}</div>
                                                                        </Form.Group>
                                                                    </Col>
                                                                    <Col lg='6'>
                                                                        <Form.Group>
                                                                            <Form.Label>Next Visit Instructions</Form.Label>
                                                                            <Form.Control as='textarea' className="custom-height" placeholder='' rows={2} name='nextVisit' onChange={this.handleChange}/>
                                                                            <div className="invalid-feedback">{this.state.protocol["nextVisit"]}</div>
                                                                        </Form.Group>
                                                                    </Col>
                                                                    <Col lg='6'>
                                                                        <Form.Group>
                                                                            <Form.Label>Drug Interactions</Form.Label>
                                                                            <Form.Control as='textarea' className="custom-height" placeholder='' rows={2} name='drugInteraction' onChange={this.handleChange}/>
                                                                            <div className="invalid-feedback">{this.state.protocol["drugInteraction"]}</div>
                                                                        </Form.Group>
                                                                    </Col> 
                                                                    <Col lg='6'>
                                                                        <Form.Group>
                                                                            <Form.Label>Stockist Instructions</Form.Label>
                                                                            <Form.Control as='textarea' className="custom-height"placeholder='' rows={2} name='instructStockist' onChange={this.handleChange}/>
                                                                            <div className="invalid-feedback">{this.state.protocol["instructStockist"]}</div>
                                                                        </Form.Group>
                                                                    </Col> 
                                                                    <Col lg='6'>
                                                                        <Form.Group>
                                                                            <Form.Label>Adverse Events</Form.Label>
                                                                            <Form.Control as='textarea' className="custom-height" placeholder='' rows={2} name='adverseEvent' onChange={this.handleChange}/>
                                                                            <div className="invalid-feedback">{this.state.protocol["adverseEvent"]}</div>
                                                                        </Form.Group>
                                                                    </Col>
                                                                </Row>
                                                                <Row>
                                                                    <Col lg='6'>
                                                                        <Form.Group>
                                                                            <Form.Label>Risk of Death</Form.Label>
                                                                            <Form.Control as='textarea' className="custom-height" placeholder='' rows={2} name='riskDeath' onChange={this.handleChange}/>
                                                                            <div className="invalid-feedback">{this.state.protocol["riskDeath"]}</div>
                                                                        </Form.Group>
                                                                    </Col>
                                                                    <Col lg='6'>
                                                                        <Form.Group>
                                                                            <Form.Label>Reference</Form.Label>
                                                                            <Form.Control as='textarea' className="custom-height" placeholder='' rows={2} name='reference' onChange={this.handleChange}/>
                                                                            <div className="invalid-feedback">{this.state.protocol["reference"]}</div>
                                                                        </Form.Group>
                                                                    </Col>
                                                                    <Col lg='12'>
                                                                        <div className="form-button text-center">
                                                                            <Button type="button" className="btn pt-2 pb-2 btn-secondary" onClick={this.saveProtocol.bind(this)}>
                                                                                {this.state.saveLoader && (
                                                                                    <Spinner className='mr-3' animation='border' size='1.5rem' />
                                                                                )}
                                                                                {!this.state.saveLoader && (
                                                                                    <FaSave className='mr-2' size='1.5rem' style={{ verticalAlign: "sub" }} />
                                                                                )}
                                                                                Save & Next
                                                                            </Button>
                                                                        </div>
                                                                    </Col>
                                                                </Row>
                                                            </div>
                                                        </div> 
                                                    </Tab.Pane>
                                                    <Tab.Pane eventKey="second">
                                                        <div id="chemomedicineTab">
                                                            <Row>
                                                                <Col lg='12'>
                                                                    <Button variant="secondary" className="btn pull-right mb-1" onClick={() => this.setState({ showChemoMedicinePopup: true })}>New Chemo Medicine</Button>
                                                                </Col>
                                                            </Row>
                                                            <Row>
                                                                <Col lg='12'>
                                                                    <table className="table table-striped table-hover" role="grid">
                                                                        <thead className="thead-light">
                                                                            <tr role="row">
                                                                                <th className="sorting_asc" aria-controls="example" colSpan="1" aria-sort="ascending">#</th>
                                                                                <th className="sorting_asc" aria-controls="example" colSpan="1" aria-sort="ascending">Medicine</th>
                                                                                <th className="sorting_asc" aria-controls="example" colSpan="1" aria-sort="ascending">Dosage Method</th>
                                                                                <th className="sorting_asc" aria-controls="example" colSpan="1" aria-sort="ascending">Action</th>
                                                                            </tr>
                                                                        </thead>
                                                                        <tbody>
                                                                            { this.state.chemoMedicineList.map(function (d, idx) {
                                                                                return (
                                                                                    <tr key={idx} role="row" className="odd">
                                                                                        <td>{idx + 1}</td>
                                                                                        <td>{d.chemoMedicineName}</td>
                                                                                        <td>{d.chemoInstructions}</td>
                                                                                        <td>
                                                                                            <a className='text-primary font-w500' onClick={() => _this.deleteChemo(d.medicineId)}>
                                                                                                <FaRegTrashAlt className='text-red ml-4' style={{verticalAlign: 'text-bottom'}}/>
                                                                                            </a>
                                                                                        </td>
                                                                                    </tr>
                                                                                );
                                                                            })}
                                                                        </tbody>
                                                                    </table>
                                                                </Col> 
                                                                <Col lg='12'>
                                                                    <div className="form-button text-center">
                                                                        <Button type="button" className="btn pt-2 pb-2 btn-secondary" onClick={this.saveChemo.bind(this)}>
                                                                            {this.state.saveLoader && (
                                                                                <Spinner className='mr-3' animation='border' size='1.5rem' />
                                                                            )}
                                                                            {!this.state.saveLoader && (
                                                                                <FaSave className='mr-2' size='1.5rem' style={{ verticalAlign: "sub" }} />
                                                                            )}
                                                                            Save & Next
                                                                        </Button>
                                                                    </div>
                                                                </Col>
                                                            </Row>
                                                        </div>
                                                    </Tab.Pane>
                                                    <Tab.Pane eventKey="third">
                                                        <div id="protocolDosageTab">
                                                            <Row>
                                                                <Col lg='12'>
                                                                    <Button variant="secondary" className="btn pull-right mb-1" onClick={this.showProtocolDosagePopup.bind(this)}>Add Chemo Dosage</Button>
                                                                </Col>
                                                            </Row>
                                                            <Row>
                                                                <Col lg='12'>
                                                                    <table className="table table-striped table-hover" role="grid">
                                                                        <thead className="thead-light">
                                                                            <tr role="row">
                                                                                <th className="sorting_asc" aria-controls="example" colSpan="1" aria-sort="ascending">#</th>
                                                                                <th className="sorting_asc" aria-controls="example" colSpan="1" aria-sort="ascending">Chemo medicine</th>
                                                                                <th className="sorting_asc" aria-controls="example" colSpan="1" aria-sort="ascending">Dosage</th>
                                                                                <th className="sorting_asc" aria-controls="example" colSpan="1" aria-sort="ascending">Dosage Qty</th>
                                                                                <th className="sorting_asc" aria-controls="example" colSpan="1" aria-sort="ascending">Unit</th>
                                                                                <th className="sorting_asc" aria-controls="example" colSpan="1" aria-sort="ascending">Action</th>
                                                                            </tr>
                                                                        </thead>
                                                                        <tbody>
                                                                            { this.state.protocolDosageList.map(function (d, idx) {
                                                                                return (
                                                                                    <tr key={idx} role="row" className="odd">
                                                                                        <td>{idx + 1}</td>
                                                                                        <td>{d.chemoMedicineDosageValue}</td>
                                                                                        <td>{d.dosageValues}</td>
                                                                                        <td>{d.dosageQtys}</td>
                                                                                        <td>{d.dosageUnitValues}</td>
                                                                                        <td>
                                                                                            <a className='text-primary font-w500' onClick={() => _this.deleteProtocolDosage(d.chemoMedicineDosageID, d.dosageValues, d.dosageQtys)}>
                                                                                                <FaRegTrashAlt className='text-red ml-4' style={{verticalAlign: 'text-bottom'}}/>
                                                                                            </a>
                                                                                        </td>
                                                                                    </tr>
                                                                                );
                                                                            })}
                                                                        </tbody>
                                                                    </table>
                                                                 </Col>
                                                                 <Col lg='12'>
                                                                    <div className="form-button text-center">
                                                                        <Button type="button" className="btn pt-2 pb-2 btn-secondary" onClick={this.saveProtocolDosage.bind(this)}>
                                                                            {this.state.saveLoader && (
                                                                                <Spinner className='mr-3' animation='border' size='1.5rem' />
                                                                            )}
                                                                            {!this.state.saveLoader && (
                                                                                <FaSave className='mr-2' size='1.5rem' style={{ verticalAlign: "sub" }} />
                                                                            )}
                                                                            Save & Next
                                                                        </Button>
                                                                    </div>
                                                                </Col>
                                                            </Row> 
                                                        </div>
                                                    </Tab.Pane>
                                                    <Tab.Pane eventKey="fourth">
                                                        <div id="preconditionMST">
                                                            <Row>
                                                                <Col lg='12'>
                                                                    <Button variant="secondary" className="btn pull-right mb-1" onClick={this.showPreConditionMSTPopup.bind(this)}>Add Pre-Condition</Button>
                                                                </Col>
                                                            </Row> 
                                                            <Row>
                                                                <Col lg='12'>
                                                                    <table className="table table-striped table-hover" role="grid">
                                                                        <thead className="thead-light">
                                                                            <tr role="row">
                                                                                <th className="sorting_asc" aria-controls="example" colSpan="1" aria-sort="ascending">#</th>
                                                                                <th className="sorting_asc" aria-controls="example" colSpan="1" aria-sort="ascending">Report Parameter</th>
                                                                                <th className="sorting_asc" aria-controls="example" colSpan="1" aria-sort="ascending">Comparision</th>
                                                                                <th className="sorting_asc" aria-controls="example" colSpan="1" aria-sort="ascending">Value</th>
                                                                                <th className="sorting_asc" aria-controls="example" colSpan="1" aria-sort="ascending">Action</th>
                                                                            </tr>
                                                                        </thead>
                                                                        <tbody>
                                                                            { this.state.preConditionMSTList.map(function (d, idx) {
                                                                                return (
                                                                                    <tr key={idx} role="row" className="odd">
                                                                                        <td>{idx + 1}</td>
                                                                                        <td>{d.reportParamsNames}</td>
                                                                                        <td>{d.preConditionListsNames}</td>
                                                                                        <td>{d.preConditionValues}</td>
                                                                                        <td>
                                                                                            <a className='text-primary font-w500' onClick={() => _this.deletePrecondition(d.reportParamsID, d.preConditionValues)}>
                                                                                                <FaRegTrashAlt className='text-red ml-4' style={{verticalAlign: 'text-bottom'}}/>
                                                                                            </a>
                                                                                        </td>
                                                                                    </tr>
                                                                                );
                                                                            })}
                                                                        </tbody>
                                                                    </table>
                                                                 </Col>
                                                                 <Col lg='12'>
                                                                    <div className="form-button text-center">
                                                                        <Button type="button" className="btn pt-2 pb-2 btn-secondary" onClick={this.savePreConditionMST.bind(this)}>
                                                                            {this.state.saveLoader && (
                                                                                <Spinner className='mr-3' animation='border' size='1.5rem' />
                                                                            )}
                                                                            {!this.state.saveLoader && (
                                                                                <FaSave className='mr-2' size='1.5rem' style={{ verticalAlign: "sub" }} />
                                                                            )}
                                                                            Save & Next
                                                                        </Button>
                                                                    </div>
                                                                </Col>
                                                            </Row> 
                                                        </div>
                                                    </Tab.Pane>
                                                    <Tab.Pane eventKey="fifth">
                                                        <div id="reduceDosageTab">
                                                            <Row>
                                                                <Col lg='12'>
                                                                    <Button variant="secondary" className="btn pull-right mb-1" onClick={this.showReduceDosagePopup.bind(this)}>Add Dosage Reduction</Button>
                                                                </Col>
                                                            </Row>
                                                            <Row>
                                                                <Col lg='12'>
                                                                    <table className="table table-striped table-hover" role="grid">
                                                                        <thead className="thead-light">
                                                                            <tr role="row">
                                                                                <th className="sorting_asc" aria-controls="example" colSpan="1" aria-sort="ascending">#</th> 
                                                                                <th className="sorting_asc" aria-controls="example" colSpan="1" aria-sort="ascending">Adverse Event</th> 
                                                                                <th className="sorting_asc" aria-controls="example" colSpan="1" aria-sort="ascending">Chemo medicine</th>
                                                                                <th className="sorting_asc" aria-controls="example" colSpan="1" aria-sort="ascending">Action</th>
                                                                            </tr>
                                                                        </thead>
                                                                        <tbody>
                                                                            { this.state.reduceDosageList.map(function (d, idx) {
                                                                                return (
                                                                                    <tr key={idx} role="row" className="odd">
                                                                                        <td>{idx + 1}</td>
                                                                                        <td>{d.reduceDosageReportValues}</td>
                                                                                        <td>{d.chemoMedicineDosageValue}</td>
                                                                                        <td>
                                                                                            <a className='text-primary font-w500' onClick={() => _this.deleteReduceDosage(d.chemoMedicineDosageID, d.reduceDosageReportID)}>
                                                                                                <FaRegTrashAlt className='text-red ml-4' style={{verticalAlign: 'text-bottom'}}/>
                                                                                            </a>
                                                                                        </td>
                                                                                    </tr>
                                                                                );
                                                                                })}
                                                                        </tbody>
                                                                    </table>
                                                                 </Col>
                                                                 <Col lg='12'>
                                                                    <div className="form-button text-center">
                                                                        <Button type="button" className="btn pt-2 pb-2 btn-secondary" onClick={this.saveReduceDosage.bind(this)}>
                                                                            {this.state.saveLoader && (
                                                                                <Spinner className='mr-3' animation='border' size='1.5rem' />
                                                                            )}
                                                                            {!this.state.saveLoader && (
                                                                                <FaSave className='mr-2' size='1.5rem' style={{ verticalAlign: "sub" }} />
                                                                            )}
                                                                            Save & Next
                                                                        </Button>
                                                                    </div>
                                                                </Col>
                                                            </Row> 
                                                        </div>
                                                    </Tab.Pane>
                                                    <Tab.Pane eventKey="sixth">
                                                        <div id="adverseEffectDisTab">
                                                            <Row>
                                                                <Col lg='12'>
                                                                    <Button variant="secondary" className="btn pull-right mb-1" onClick={this.showAdverseEffectDisPopup.bind(this)}>New Adverse Event</Button>
                                                                </Col>
                                                            </Row>
                                                            <Row>
                                                                <Col lg='12'>
                                                                    <table className="table table-striped table-hover" role="grid">
                                                                        <thead className="thead-light">
                                                                            <tr role="row">
                                                                            <th className="sorting_asc" aria-controls="example" colSpan="1" aria-sort="ascending">#</th> 
                                                                                <th className="sorting_asc" aria-controls="example" colSpan="1" aria-sort="ascending">Adverse Event</th> 
                                                                                <th className="sorting_asc" aria-controls="example" colSpan="1" aria-sort="ascending">Chemo medicine</th>
                                                                                <th className="sorting_asc" aria-controls="example" colSpan="1" aria-sort="ascending">Action</th>
                                                                            </tr>
                                                                        </thead>
                                                                         <tbody>
                                                                            { this.state.advEffDiscontinueList.map(function (d, idx) {
                                                                                return (
                                                                                    <tr key={idx} role="row" className="odd">
                                                                                        <td>{idx + 1}</td>
                                                                                        <td>{d.reportValues}</td>
                                                                                        <td>{d.chemoMedicineDosageValue}</td>
                                                                                        <td>
                                                                                            <a className='text-primary font-w500' onClick={() => _this.deleteAdverseEventDIS(d.reportID)}>
                                                                                                <FaRegTrashAlt className='text-red ml-4' style={{verticalAlign: 'text-bottom'}}/>
                                                                                            </a>
                                                                                        </td>
                                                                                    </tr>
                                                                                );
                                                                            })}
                                                                        </tbody> 
                                                                    </table>
                                                                 </Col>
                                                                 <Col lg='12'>
                                                                    <div className="form-button text-center">
                                                                        <Button type="button" className="btn pt-2 pb-2 btn-secondary" onClick={this.saveAdverseDiscontinue.bind(this)}>
                                                                            {this.state.saveLoader && (
                                                                                <Spinner className='mr-3' animation='border' size='1.5rem' />
                                                                            )}
                                                                            {!this.state.saveLoader && (
                                                                                <FaSave className='mr-2' size='1.5rem' style={{ verticalAlign: "sub" }} />
                                                                            )}
                                                                            Save & Next
                                                                        </Button>
                                                                    </div>
                                                                </Col>
                                                            </Row> 
                                                        </div>
                                                    </Tab.Pane>
                                                    <Tab.Pane eventKey="seventh">
                                                        <div id="adverseEffectTerTab">
                                                            <Row>
                                                                <Col lg='12'>
                                                                    <Button variant="secondary" className="btn pull-right mb-1" onClick={() => this.setState({ showAdverseEffectTerPopup: true })}>New Adverse Event</Button>
                                                                </Col>
                                                            </Row>
                                                            <Row>
                                                                <Col lg='12'>
                                                                    <table className="table table-striped table-hover" role="grid">
                                                                        <thead className="thead-light">
                                                                            <tr role="row">
                                                                                <th className="sorting_asc" aria-controls="example" colSpan="1" aria-sort="ascending">#</th> 
                                                                                <th className="sorting_asc" aria-controls="example" colSpan="1" aria-sort="ascending">Adverse Event</th> 
                                                                                <th className="sorting_asc" aria-controls="example" colSpan="1" aria-sort="ascending">message</th>
                                                                                <th className="sorting_asc" aria-controls="example" colSpan="1" aria-sort="ascending">Action</th>
                                                                            </tr>
                                                                        </thead>
                                                                        <tbody>
                                                                            { this.state.advEffTerminateList.map(function (d, idx) {
                                                                                return (
                                                                                    <tr key={idx} role="row" className="odd">
                                                                                        <td>{idx + 1}</td>
                                                                                        <td>{d.reportName}</td>
                                                                                        <td>{d.message}</td>
                                                                                        <td>
                                                                                            <a className='text-primary font-w500' onClick={() => _this.deleteAdverseEffectTER(d.reportID)}>
                                                                                                <FaRegTrashAlt className='text-red ml-4' style={{verticalAlign: 'text-bottom'}}/>
                                                                                            </a>
                                                                                        </td>
                                                                                    </tr>
                                                                                );
                                                                                })}
                                                                        </tbody>
                                                                    </table>
                                                                 </Col>
                                                                 <Col lg='12'>
                                                                    <div className="form-button text-center">
                                                                        <Link to="/ProtocolMaster" className="btn pt-2 pb-2 btn-secondary" onClick={this.saveAdverseEffectTer.bind(this)}>Save & Close</Link>
                                                                    </div>
                                                                </Col>
                                                            </Row> 
                                                        </div>
                                                    </Tab.Pane>
                                                </Tab.Content>
                                            </Col>
                                        </Row>
                                    </Tab.Container>
                                </section>
                            </div>
                        </Container>
                        <ChemoMedicinePopup
                            saveChemoMedicine={(data) => this.setChemoMedicineHandler(data)}
                            showChemoMedicinePopup={this.state.showChemoMedicinePopup} closeModal={() => this.closeChemoMedicinePopup()}
                        />
                        <ProtocolDosagePopup 
                            ref={this.protocolDosageChild}
                            saveProtocolDosageTable={(data) => this.setProtocolDosageHandler(data)}
                            showProtocolDosagePopup={this.state.showProtocolDosagePopup} closeModal={() => this.closeProtocolDosagePopup()}
                        />
                        <PreConditionMSTPopup 
                            savePreConditionMST={(data) => this.setPreConditionMSTHandler(data)}
                            showPreConditionMSTPopup={this.state.showPreConditionMSTPopup} closeModal={() => this.closePreConditionMSTPopup()}
                        />
                        <ReduceDosagePopup
                            ref={this.reduceDosageChild}
                            saveReduceDosageTable={(data) => this.setReduceDosageHandler(data)}
                            showReduceDosagePopup={this.state.showReduceDosagePopup} closeModal={() => this.closeReduceDosagePopup()}
                        />
                        <AdverseEffectDisPopup
                            ref={this.adverseEffectChild}
                            saveAdvEffDiscontinue={(data) => this.setAdvEffDiscontinueHandler(data)}
                            showAdverseEffectDisPopup={this.state.showAdverseEffectDisPopup} closeModal={() => this.closeAdverseEffectDisPopup()}
                        />
                        <AdverseEffectTerPopup 
                            saveAdvEffTerminate={(data) => this.setAdvEffTerminateHandler(data)}
                            showAdverseEffectTerPopup={this.state.showAdverseEffectTerPopup}  closeModal={() => this.closeAdverseEffectTerPopup()}
                        />
                    </div>
                </div>
            </div>
        )
    }
}